<template>
  <div class="joinUs-page">
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="all-container">
      <img src="../../assets/img/joinUs/banner_bg.png" alt="" class="banner_bg">
      <div class="join-us-modular-container">
        <div class="center-container">
          <div class="nav-search-container">
            <div class="search-container">
              <input type="text" class="search-inp" placeholder="请输入搜索关键字">
              <div class="search-btn">
                <img src="../../assets/img/common/shouhou.png" alt="">
              </div>
            </div>
          </div>
          <div class="join-container">
            <div class="recruit-info-container">
              <p class="card-title">热门职位</p>
              <div class="card-content-container">
                <ul class="recruit-job-list-container">
                  <li class="recruit-job-item-container">
                    <a href="javascript:;" @click="jump( 'positionList' ,  '0' )">
                      <p class="recruit-job-name">Java工程师</p>
                      <p class="recruit-job-info">
                        <span>工作地点：杭州市 / 招聘人数：1人</span>
                      </p>
                    </a>
                    <a href="javascript:;" class="position-item-apply-btn" @click="jump( 'positionList' ,  '0' )">申请</a>
                    <img src="../../assets/img/index/youjiantou.png" alt="" @click="jump( 'positionList' ,  '0' )" class="youjiantou">
                  </li>
                  <li class="recruit-job-item-container">
                    <a href="javascript:;" @click="jump( 'positionList' , 1 )">
                      <p class="recruit-job-name">创意设计师</p>
                      <p class="recruit-job-info">
                        <span>工作地点：杭州市 / 招聘人数：1人</span>
                      </p>
                    </a>
                    <a href="javascript:;" class="position-item-apply-btn" @click="jump( 'positionList' , 1 )">申请</a>
                    <img src="../../assets/img/index/youjiantou.png" alt="" @click="jump( 'positionList' , 1 )" class="youjiantou">
                  </li>
                  <li class="recruit-job-item-container">
                    <a href="javascript:;" @click="jump( 'positionList' , 2 )">
                      <p class="recruit-job-name">产品经理</p>
                      <p class="recruit-job-info">
                        <span>工作地点：杭州市 / 招聘人数：1人</span>
                      </p>
                    </a>
                    <a href="javascript:;" class="position-item-apply-btn" @click="jump( 'positionList' , 2 )">申请</a>
                    <img src="../../assets/img/index/youjiantou.png" alt="" @click="jump( 'positionList' , 2 )" class="youjiantou">
                  </li>
                  <li class="recruit-job-item-container">
                    <a href="javascript:;" @click="jump( 'positionList' , 3 )">
                      <p class="recruit-job-name">高级产品总监</p>
                      <p class="recruit-job-info">
                        <span>工作地点：杭州市 / 招聘人数：1人</span>
                      </p>
                    </a>
                    <a href="javascript:;" class="position-item-apply-btn" @click="jump( 'positionList' , 3 )">申请</a>
                    <img src="../../assets/img/index/youjiantou.png" alt="" @click="jump( 'positionList' , 3 )" class="youjiantou">
                  </li>
                  <li class="recruit-job-item-container">
                    <a href="javascript:;" @click="jump( 'positionList' , 4 )">
                      <p class="recruit-job-name">Web前端开发工程师</p>
                      <p class="recruit-job-info">
                        <span>工作地点：杭州市 / 招聘人数：1人</span>
                      </p>
                    </a>
                    <a href="javascript:;" class="position-item-apply-btn" @click="jump( 'positionList' , 4 )">申请</a>
                    <img src="../../assets/img/index/youjiantou.png" alt="" @click="jump( 'positionList' , 4 )" class="youjiantou">
                  </li>
                </ul>
              </div>
            </div>
            <div class="team-info-container">
              <p class="card-title">精英团队</p>
              <div class="card-content-container">
                <div class="card-item-content-container">
                  <img src="../../assets/img/common/teamMember1.webp" alt="" class="card-content-logo">
                  <div class="card-info-container">
                    <p>
                      <span class="fullName">高炎 / </span>
                      <span class="position">总经理</span>
                    </p>
                    <p class="card-describe">
                      任职浙大常州工业转化研究院智能互联团队负责人、浙江大学物联网网络国家重点实验室、创业路上"中年大叔"、10年+ 技术+产品+运营...
                    </p>
                  </div>
                </div>
                <div class="card-item-content-container">
                  <img src="../../assets/img/common/teamMember2.webp" alt="" class="card-content-logo">
                  <div class="card-info-container">
                    <p>
                      <span class="fullName">孙中赛 / </span>
                      <span class="position">产品总监</span>
                    </p>
                    <p class="card-describe">
                      负责公司数据中台架构、核心产品线策略制定、实施及产品生命周期管理、确认产品路线图、产品调研、产品策划、产品发布...
                    </p>
                  </div>
                </div>
                 <div class="card-item-content-container">
                  <img src="../../assets/img/common/teamMember3.webp" alt="" class="card-content-logo">
                  <div class="card-info-container">
                    <p>
                      <span class="fullName">龙迎春 / </span>
                      <span class="position">浙大研究院智能互联专家</span>
                    </p>
                    <p class="card-describe">
                      任职浙江大学技术研究院物联通信部、数字乡村实验室带头人、硬件开发工程师及测试技术团队负责人、10年+ 技术+产品...
                    </p>
                  </div>
                </div>
                <div class="card-item-content-container">
                  <img src="../../assets/img/common/teamMember5.png" alt="" class="card-content-logo">
                  <div class="card-info-container">
                    <p>
                      <span class="fullName">娄李伟 / </span>
                      <span class="position"> 浙江农业科学院专家</span>
                    </p>
                    <p class="card-describe">
                      中国数字乡村发展创新联盟专家委员会委员 理事
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'
export default {
  name: 'joinUs',  
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
   methods: {
    jump( pathName , id ){
      this.$router.push({
        name: pathName,
        query: {
          id: id,
        }
      })
    }
  }
}
</script>
<style lang="scss">

</style>
